<template>
	<div class="events-list-container">
		<v-container grid-list-sm fluid>
			<v-layout>
				<!-- <v-flex v-for=" event in eventslist " :key="event.id" xs12 md6 lg4> -->
				<masonry :gutter="{ default: '16px' }" :cols="{ default: 2, 960: 1 }">
					<v-card v-for="event in eventslist" :key="event.id" raised class="event-card" dark :color="event.color ? '#' + event.color : ''" @click="goToEventDetails(event.id)">
						<v-img class="event-thumbnail" :src="parseEventImage(event.image_url)" gradient="180deg, rgba(18,30,38,0.2) 0%, rgba(18,30,38,0.9) 70%">
							<div class="event-content">
								<div class="event-content-inner">
									<v-card-title class="d-block">
										<div class="event-categories">
											<template v-for="(category, catkey) in event.event_type">
												<span class="event-category" v-if="category != 'Evente'" :key="catkey">{{ category }}</span>
											</template>
										</div>
										<h2 class="event-title">{{ event.name }}</h2>
									</v-card-title>
									<v-card-text class="event-details">
										<div class="event-detail-item">
											<v-icon class="event-detail-icon">event</v-icon>
											<div class="event-detail-value">{{ event.dates.range }}</div>
										</div>
										<div class="event-detail-item" v-if="event.location_name">
											<v-icon class="event-detail-icon">place</v-icon>
											<div class="event-detail-value">{{ event.location_name }}</div>
										</div>
									</v-card-text>
								</div>
							</div>
						</v-img>
					</v-card>
				</masonry>
				<!-- </v-flex> -->
			</v-layout>
		</v-container>
		<CityEventDetails :showdetailsdialog="showdetailsdialog" :event="selectedevent"></CityEventDetails>
	</div>
</template>

<script>
import native_capacitor from '@/config/js_helper/native_capacitor';
import DateUtils from '@/config/js_helper/DateUtils';
import { TIRANA_XXL_API } from '@/config/api/url/urls_in_app';
import { API_CLIENT_GET_AXIOS } from '@/config/api/api_call/service_instances';
import CityEventDetails from '../details/CityEventDetails';
export default {
	name: 'CityEventsList',
	props: {},
	components: {
		CityEventDetails,
	},
	data() {
		return {
			dataloaded: false,
			emptyresult: false,
			errorloading: false,
			eventslist: [],
			showdetailsdialog: false,
			selectedeventid: null,
		};
	},
	computed: {
		selectedevent() {
			let event = null;
			if (this.selectedeventid) {
				event = this.eventslist.find((item) => item.id == this.selectedeventid);
			}
			return event;
		},
	},
	watch: {
		$route(to, from) {
			if (to.name == 'cityevents') {
				this.$store.state.active_loader = false;
			}
			this.setEventDetails();
		},
		showdetailsdialog(newvalue) {
			if (!newvalue) {
				this.selectedeventid = null;
			}
		},
	},
	created() {
		this.getList();
		this.setEventDetails();
	},
	methods: {
		getList() {
			API_CLIENT_GET_AXIOS(TIRANA_XXL_API)
				.then((response) => {
					if (response && response.events && Array.isArray(response.events) == false) {
						if (Array.isArray(response.events) == false) {
							this.eventsObjToArray(response.events);
							//this.eventslist = response.events
							this.dataloaded = true;
						} else {
							this.emptyresult = true;
						}
					} else {
						this.errorloading = true;
					}
					this.$store.state.active_loader = false;
					this.setEventDetails();
				})
				.catch((err) => {
					this.errorloading = true;
					this.$store.state.active_loader = false;
				});
		},
		eventsObjToArray(objlist) {
			let eventslist = [];
			for (const [objid, event] of Object.entries(objlist)) {
				let iswithincity = !event.event_type || !Object.keys(event.event_type).includes('455');
				if (iswithincity) {
					let startdate = DateUtils.unix(event.start).utc();
					let enddate = DateUtils.unix(event.end).utc();
					let sortdate = event.start;
					let checkeddates = this.checkEventDates(startdate, enddate, sortdate, event.repeats || []);
					if (checkeddates.isfuture) {
						event.id = objid;
						event.dates = this.formatEventDates(checkeddates.start, checkeddates.end);
						event.dates.sortdate = checkeddates.sortdate;
						event.gradient = '180deg, rgba(18,30,38,0.2) 0%, rgba(18,30,38,0.9) 70%';
						eventslist.push(event);
					}
				}
			}
			eventslist.sort((a, b) => {
				return a.dates.sortdate - b.dates.sortdate;
			});
			this.eventslist = eventslist;
		},
		formatEventDates(startdate, enddate) {
			let dates = {
				start: startdate.format('dddd D MMMM YYYY'),
				end: enddate.format('dddd D MMMM YYYY'),
			};
			if (enddate.isAfter(startdate, 'hour')) {
				dates.range = startdate.format('dddd D MMMM YYYY, HH:mm') + ' - ' + enddate.format('HH:mm');
			} else if (enddate.isAfter(startdate, 'day')) {
				dates.range = startdate.format('dddd D MMMM YYYY, HH:mm') + ' - ' + enddate.format('dddd D MMMM YYYY, HH:mm');
			} else {
				dates.range = startdate.format('dddd D MMMM YYYY, HH:mm');
			}
			return dates;
		},
		checkEventDates(startdate, enddate, sortdate, repeats) {
			let isfuture = false;
			let checkedstart = startdate;
			let checkedend = enddate;
			let checksortdate = sortdate;
			if (repeats.length) {
				isfuture = repeats.some((daterange) => {
					let instanceenddate = DateUtils.unix(daterange[1]).utc();
					let shouldinclude = instanceenddate.isSameOrAfter(DateUtils());
					if (shouldinclude) {
						checkedstart = DateUtils.unix(daterange[0]).utc();
						checkedend = instanceenddate;
						checksortdate = daterange[0];
						return true;
					} else {
						return false;
					}
				});
			} else {
				isfuture = enddate.isSameOrAfter(DateUtils());
			}
			return { isfuture: isfuture, start: checkedstart, end: checkedend, sortdate: checksortdate };
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		goToEventDetails(eventid) {
			this.$router.push({ name: 'cityeventdetails', params: { id: eventid } });
		},
		setEventDetails() {
			if (this.dataloaded && this.$route.name == 'cityeventdetails' && this.$route.params.id) {
				this.selectedeventid = this.$route.params.id;
				this.showdetailsdialog = true;
			} else {
				this.showdetailsdialog = false;
				this.selectedeventid = null;
			}
		},
		parseEventImage(url) {
			let parsedurl = url;
			if (url) {
				parsedurl = url.replace('http://', 'https://');
			}
			return parsedurl;
		},
	},
};
</script>

<style scoped lang="scss">
.events-list-container {
	padding-bottom: 50px;
}
.event-card {
	margin-bottom: 16px;
}
.event-content {
	display: flex;
	align-items: flex-end;
	height: 100%;
	text-shadow: 0px 0px 50px black;
	.event-title {
		font-size: 2rem;
		line-height: 1.3;
		text-transform: uppercase;
	}
	.event-category {
		text-transform: uppercase;
		font-size: 0.8em;
		display: inline-block;
		margin-right: 5px;
	}
	.event-details {
		padding-top: 0 !important;
		font-weight: 400;
		.event-detail-item {
			display: flex;
			margin-bottom: 3px;
			//align-items: center;
			.event-detail-icon {
				margin-right: 10px;
			}
			.event-detail-value {
				padding-top: 2px;
				flex-grow: 1;
			}
		}
	}
}
</style>
